// extracted by mini-css-extract-plugin
export default {"addressAction":"L6-z","loading":"M6-z"};